/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { OrmService, Schema } from '../schema/orm.service';
import { AbstractGenFirestoreService } from '@res/ngg-core';
@Injectable({
  providedIn: 'root',
  deps: [],
})
export class StorageFirestoreService extends AbstractGenFirestoreService<Schema, 'storage'> {
  constructor() {
    super(inject(OrmService).storageCollection);
  }
}
